module.exports = __webpack_public_path__ + "img/mobile-card.4f66d05d.svg";